
import { motion } from 'framer-motion';

export default function EULogoBanner() {
  return (
    <section className="w-full bg-white">
      <div className="w-full bg-[#003399] py-1.5 sm:py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-center gap-2 sm:gap-3">
          <span
            className="text-white text-[10px] sm:text-xs tracking-wide text-center"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Projekt współfinansowany ze środków Unii Europejskiej
          </span>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8"
      >
        <div className="flex flex-row items-center justify-center gap-4 sm:gap-8 md:gap-12">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-8 h-8 sm:w-12 sm:h-12 flex items-center justify-center rounded-full bg-[#003399] flex-shrink-0">
              <span
                className="text-[#FFD700] text-xs sm:text-lg font-bold"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                FE
              </span>
            </div>
            <div className="flex flex-col">
              <span
                className="text-[#003399] text-[9px] sm:text-xs font-bold leading-tight"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Fundusze Europejskie
              </span>
              <span
                className="text-[#003399] text-[8px] sm:text-[10px] leading-tight hidden sm:block"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                dla Nowoczesnej Gospodarki
              </span>
            </div>
          </div>

          <div className="w-px h-8 sm:h-12 bg-gray-300"></div>

          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-10 h-8 sm:w-16 sm:h-12 flex items-center justify-center rounded overflow-hidden bg-[#003399] relative flex-shrink-0">
              <div className="relative w-6 h-6 sm:w-10 sm:h-10">
                {Array.from({ length: 12 }).map((_, i) => {
                  const angle = (i * 30 - 90) * (Math.PI / 180);
                  const x = 50 + 38 * Math.cos(angle);
                  const y = 50 + 38 * Math.sin(angle);
                  return (
                    <span
                      key={i}
                      className="absolute text-[#FFD700] text-[5px] sm:text-[8px] leading-none"
                      style={{
                        left: `${x}%`,
                        top: `${y}%`,
                        transform: 'translate(-50%, -50%)',
                      }}
                    >
                      ★
                    </span>
                  );
                })}
              </div>
            </div>
            <div className="flex flex-col">
              <span
                className="text-[#003399] text-[9px] sm:text-xs font-bold leading-tight"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Unia Europejska
              </span>
              {/* Fixed the JSX by separating the line break from the text */}
              <span
                className="text-[#003399] text-[8px] sm:text-[10px] leading-tight hidden sm:block"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                <>Europejski Fundusz<br />Rozwoju Regionalnego</>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-3 sm:mt-6 pt-3 sm:pt-6 border-t border-gray-200">
          <p
            className="text-center text-[#555] text-[9px] sm:text-xs leading-relaxed px-2"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Sfinansowano w ramach reakcji Unii na pandemię COVID-19.
            Projekt współfinansowany ze środków Europejskiego Funduszu Rozwoju Regionalnego
            w ramach Programu Operacyjnego Fundusze Europejskie dla Nowoczesnej Gospodarki 2021-2027.
          </p>
        </div>
      </motion.div>
    </section>
  );
}
